export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="max-w-xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">
            有任何疑问、建议或合作意向，欢迎通过以下方式与我们取得联系
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-2xl border border-secondary-100 p-5 text-center">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">商务合作</div>
              <div className="text-sm font-medium text-foreground-800">bd@91jingpin.com</div>
            </div>
            <div className="bg-background-50 rounded-2xl border border-secondary-100 p-5 text-center">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-accent-600 text-lg"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">用户反馈</div>
              <div className="text-sm font-medium text-foreground-800">feedback@91jingpin.com</div>
            </div>
            <div className="bg-background-50 rounded-2xl border border-secondary-100 p-5 text-center">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-secondary-200 flex items-center justify-center">
                <i className="ri-group-line text-secondary-600 text-lg"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">内容投稿</div>
              <div className="text-sm font-medium text-foreground-800">content@91jingpin.com</div>
            </div>
          </div>

          <p className="text-xs text-foreground-400">
            工作时间：周一至周日 9:00 - 22:00 · 通常24小时内回复
          </p>
        </div>
      </div>
    </section>
  );
}